import React from "react";
import Icon from "./Icon";
import "../styles/flowChart.css";

/**
 * Animated flow-chart diagram used in place of app/product screenshots.
 * Renders a connected chain of step nodes with an icon, a title and a
 * short detail line. Steps can be plain strings or { title, detail, icon }.
 */
function FlowChart({ steps = [], icon = "workflow", variant = "" }) {
  return (
    <div
      className={`flowchart ${variant}`}
      role="list"
      aria-label="Process flow"
    >
      {steps.map((step, index) => {
        const title = typeof step === "string" ? step : step.title;
        const detail = typeof step === "string" ? null : step.detail;
        const stepIcon = (typeof step === "object" && step.icon) || icon;
        const isLast = index === steps.length - 1;

        return (
          <div className="flowchart-item" key={title} role="listitem">
            <div className="flowchart-node">
              <div className="flowchart-node-number">
                <span className="flowchart-node-index">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="flowchart-node-icon">
                  <Icon name={stepIcon} size={18} />
                </span>
              </div>
              <div className="flowchart-node-copy">
                <span className="flowchart-node-title">{title}</span>
                {detail && (
                  <span className="flowchart-node-detail">{detail}</span>
                )}
              </div>
            </div>

            {!isLast && (
              <span className="flowchart-connector" aria-hidden="true">
                <span className="flowchart-connector-line" />
                <Icon
                  name="arrow"
                  size={14}
                  className="flowchart-connector-arrow"
                />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default FlowChart;
